module.exports = __webpack_public_path__ + "static/media/7.323c94b4.jpg";